import React, { useEffect, useState } from "react";

import {
  Button,
  makeStyles,
  Popover,
  Tooltip,
  Typography,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconAlignTop from "app/common/Icon/IconAlignTop";
const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(1),
  },
  rowItem: {
    boxShadow: theme.shadows[1],
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(1),
  },
  colItem: {
    display: "flex",
    padding: theme.spacing(0.5, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
    fontSize: "0.85rem",
    color: "#555",
    justifyContent: "space-between",
  },
  labelCol: {
    fontWeight: 600,
    color: "#333",
  },
  valueCol: {
    fontWeight: 500,
    color: "#000",
    wordBreak: "break-word",
    maxWidth: "60%",
  },
  mobileHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  paginationContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: theme.spacing(2),
  },
  selectionInfo: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: theme.spacing(1),
    fontWeight: 500,
  },
  clearSelection: {
    color: theme.palette.error.main,
    cursor: "pointer",
  },
  mobileCheckbox: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));
export const DynamicTable = ({
  columns = [],
  groups = [],
  editableMap = () => true,
  showMoreButton,
  name,
  minWidth = 2100,
  fitContainer = false,
}) => {
  let dataShowTable = JSON.parse(localStorage.getItem("dataShowTable")) || {};
  const [showColumnArray, setShowColumnArray] = useState([]);

  useEffect(() => {
    if (columns && showMoreButton) {
      let showColumn = [];

      if (name && dataShowTable[name] && dataShowTable[name]?.length > 0) {
        showColumn = dataShowTable[name];
      } else {
        showColumn = columns?.map((el, index) => ({
          state: el?.isHide ? false : true,
          title: el?.title,
          isFixed: false,
        }));
      }

      setShowColumnArray(showColumn);
    }
  }, []);

  const colSpanFull = showColumnArray?.reduce((acc, curr) => {
    return acc + (curr?.state ? 1 : 0);
  }, 0);

  const totalMinWidth =
    columns?.length > 0 &&
    columns?.reduce((sum, col, ind) => {
      if (
        typeof col?.width === "string" &&
        col?.width?.includes("%") &&
        showColumnArray[ind]?.state
      ) {
        const percentCol = parseInt(col?.width || 140);
        // Chuyển % sang px nếu cần, hoặc bỏ qua
        return sum + +((minWidth * percentCol) / 100 || 140); // giả định
      }
      return sum + parseInt(col?.width || 140);
    }, 0);

  return (
    <div>
      <div className="flex justify-end items-center px-2 py-2 border-b bg-gray-50 font-medium">
        <div>
          {showMoreButton && (
            <ExtraButton
              name={name}
              setShowColumnArray={setShowColumnArray}
              showColumnArray={showColumnArray}
              dataShowTable={dataShowTable}
            />
          )}
        </div>
      </div>
      <div
        className="table-root"
        style={{ overflowX: fitContainer ? "hidden" : "auto" }}
      >
        <div
          style={
            fitContainer
              ? { width: "100%" }
              : { minWidth: `${totalMinWidth}px` }
          }
        >
          <table
            className="table-container"
            style={
              fitContainer
                ? { width: "100%", tableLayout: "fixed" }
                : undefined
            }
          >
            <thead>
              <tr className="row-table-header">
                {columns.map((col, idx) => {
                  if (
                    (!col?.isHide && !showMoreButton) ||
                    showColumnArray[idx]?.state
                  ) {
                    return (
                      <th
                        key={idx}
                        width={col.width || "auto"}
                        style={{ wordWrap: "break-word" }}
                        className={
                          showColumnArray[idx]?.isFixed ? "fixed-col-left" : ""
                        }
                      >
                        {col?.title}
                      </th>
                    );
                  }
                })}
              </tr>
            </thead>
            <tbody>
              {groups?.length > 0 &&
                groups?.map((group, groupIndex) => {
                  return (
                    <React.Fragment key={group.key}>
                      <tr className="group-row">
                        <td colSpan={colSpanFull}>{group?.label}</td>
                      </tr>
                      {group?.items?.map((item, rowIndex) => {
                        const fullIndex = group.getIndex(rowIndex, groupIndex);
                        const editable = editableMap(
                          item,
                          fullIndex,
                          group.key
                        );
                        return (
                          <tr key={rowIndex}>
                            {columns.map((col, colIndex) => {
                              if (
                                !showMoreButton ||
                                (showMoreButton &&
                                  showColumnArray[colIndex]?.state)
                              ) {
                                return (
                                  <td
                                    key={colIndex}
                                    align={col?.align || "left"}
                                    style={
                                      fitContainer
                                        ? { wordWrap: "break-word", overflowWrap: "break-word" }
                                        : undefined
                                    }
                                  >
                                    {col?.render &&
                                      col.render({
                                        item,
                                        rowIndex,
                                        fullIndex,
                                        editable,
                                        type: group.key,
                                      })}
                                  </td>
                                );
                              }
                            })}
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
const ExtraButton = ({
  name,
  setShowColumnArray,
  showColumnArray,
  dataShowTable,
  isMobile,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const id = !!anchorEl ? "simple-popover" : undefined;
  const onToggle = (index, state) => {
    setShowColumnArray((prev) => {
      let newArr = prev?.map((el, ind) => {
        if (ind === index) return { ...el, state };
        else return el;
      });
      dataShowTable[name] = newArr;

      localStorage.setItem("dataShowTable", JSON.stringify(dataShowTable));
      return newArr;
    });
  };

  const onToggleFixed = (index, isFixed) => {
    setShowColumnArray((prev) => {
      let newArr = prev?.map((el, ind) => ({
        ...el,
        isFixed: ind === index ? isFixed : false,
      }));
      dataShowTable[name] = newArr;

      localStorage.setItem("dataShowTable", JSON.stringify(dataShowTable));
      return newArr;
    });
  };

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="contained"
        color="primary"
        onClick={handleClick}
        className="extra-button-table"
      >
        <div className="flex align-center justify-between">
          {!isMobile && "Xem thêm"}
          <Tooltip title="Xem thêm">
            {!!anchorEl ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
          </Tooltip>
        </div>
      </Button>
      <Popover
        id={id}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Typography className={classes.typography}>
          {showColumnArray &&
            showColumnArray?.map((el, ind) => (
              <CustomToggle
                label={el?.title}
                onToggle={onToggle}
                onToggleFixed={onToggleFixed}
                defaultValue={el?.state}
                defaultFixed={el?.isFixed}
                index={ind}
              />
            ))}

          {/* xin chao cac ban */}
        </Typography>
      </Popover>
    </div>
  );
};

const CustomToggle = ({
  label,
  defaultValue = false,
  defaultFixed = false,
  onToggle,
  onToggleFixed,
  index,
}) => {
  const [active, setActive] = useState(defaultValue);
  const [activeFixed, setActiveFixed] = useState(defaultFixed);

  const handleClick = (index) => {
    setActive((prev) => !prev);
    if (onToggle) {
      onToggle(index, !active);
    }
  };

  const handleFixed = (index) => {
    setActiveFixed((prev) => !prev);
    if (onToggleFixed) {
      onToggleFixed(index, !activeFixed);
    }
  };

  return (
    <div className="flex gap-2 align-center toggle-wraper">
      <div className="toggle-container">
        <div
          className={`custom-toggle ${active ? "active" : ""}`}
          onClick={() => handleClick(index)}
        >
          <div className="toggle-circle" />
        </div>
        <div className="flex justify-between align-center" style={{ flex: 1 }}>
          <span className="toggle-label">{label}</span>
          <Tooltip title="Cố định cột">
            <div
              className={`align-center fixed-btn ${
                activeFixed ? "visible-true" : "visible-none"
              } `}
              onClick={() => handleFixed(index)}
            >
              <IconAlignTop color="#3699FF" />
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
export default DynamicTable;
